import { ProductFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';

export function isBillAutomationViewEnabled(
  context: IAuthorizationContext,
): boolean {
  return context.featureChecker.productFeatureEnabled(
    ProductFeatures.billAutomation,
  );
}

export function isBillAutomationTableEnabled(
  context: IAuthorizationContext,
): boolean {
  return isBillAutomationViewEnabled(context) && !context.hasReadOnlyAccess();
}
